import { useTranslation } from "react-i18next";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../ui/card";
import { Switch } from "../ui/switch";
import { Moon, Sun } from "lucide-react";

export function AppearanceSettings({ theme, toggleTheme }) {
  const { t } = useTranslation();

  return (
    <Card className="bento-card">
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          {theme === "dark" ? <Moon className="w-5 h-5" /> : <Sun className="w-5 h-5" />}
          {t("settings.appearance")}
        </CardTitle>
        <CardDescription>{t("settings.customizeAppearance")}</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="flex items-center justify-between">
          <div>
            <p className="font-medium">{t("settings.darkMode")}</p>
            <p className="text-sm text-muted-foreground">{t("settings.darkModeDesc")}</p>
          </div>
          <Switch 
            checked={theme === "dark"} 
            onCheckedChange={toggleTheme} 
            data-testid="settings-theme-switch" 
          />
        </div>
      </CardContent>
    </Card>
  );
}
